export enum LocalStorageKey {
  AuthData = 'onArteWebsiteAuthdata',
  CookiesPopupVisible = 'onArteWebsiteCookiesPopupVisible',
  ArtworkMessage = 'onArteWebsiteArtworkMessage',
}
